export enum Languages {
  ru = 'ru',
  en = 'en',
  kk = 'kk'
}
export const SUPPORTED_LANGUAGES = [Languages.ru, Languages.en, Languages.kk];

export const KZ_PHONE_MASK = '+7 (___) ___-__-__';
export const SUPPORT_PHONE = '+77011005775';
export const COMMON_DATE_FORMAT = 'DD.MM.YYYY, HH:mm';
export const WIDTH_FOR_OPENED_NAVBAR = 1140;

// Тип погашения
export enum RepaymentType {
  ANNUITY = 'annuity', // Аннуитет
  DIFFERENTIATED = 'differentiated' // Дифференцированный
}

// Статус платежа
export enum PaymentStatus {
  PAID = 'paid', // Оплачено
  EXPECTED = 'expected', // Ожидается
  OVERDUE = 'overdue' // Просрочено
}
